<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Billing </b-navbar-brand>
           <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button :disabled="ffInvoiceModal.sentForRevisedApproval=='1'?true:false"  @click="openPop" size="sm" variant="warning" v-if=" mainExecutionDetails.length > 0 && mainExecutionDetails[0].finalBillingCompleted=='1'">Revised Billing Request</b-button><br>
              <span class="error" v-if="ffInvoiceModal.revisedActionTakenFromMail=='2'">Request Rejected</span>
              <span class="error" v-if="ffInvoiceModal.sentForRevisedApproval=='1'">Sent For Approval</span>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div v-if="billingTableData.length>0" class="box-header">
              <b-button
             v-if=" mainExecutionDetails.length > 0 && mainExecutionDetails[0].finalBillingCompleted=='0'"
                size="sm"
                variant="outline-dark"
                @click="showMoreItem"
                class="pull-right"
              >{{showMoreNewItem==false?"Show Existing Billing Details":"New Billing "}}</b-button>
<b-button  v-if="  mainExecutionDetails.length > 0 && mainExecutionDetails[0].finalBillingCompleted!='1' && showMoreNewItem==true" size="sm"  @click="closeBill(mainExecutionDetails[0].allModuleId)"  variant="outline-info">Close Billing</b-button>
              <!-- <b-button
                v-if="ffInvoiceModal.billingId!=''"
                size="sm"
                variant="success"
                @click="reload"
              >New Billing</b-button>-->
            </div>
            <div class="box" v-if="billingTableData.length>0">
              <!-- /.box-header v-if="showMoreNewItem==false"-->
              <div class="box-body" v-if="showMoreNewItem==true">
                <!-- <label class="box-title">
                  <u>Existing Billing Details</u>
                </label>-->
                <table id="ffContainer" class="table table-bordered">
                
                    
                  
                  <tbody>
<tr>
                      <th>#</th>
                      <th>Tally Invoice No.</th>
                      <th>Client Name</th>
                      <th>Job Type</th>
                      <th>Tally Status</th>
                      <th>Added In Tally</th>
                      <th>Date & Details</th>
                      <th>PDF</th>
                    </tr>
                    <tr
                      :style="item1.TallyResponse==''?'color:red':item1.LINEERROR=='' && item1.CREATED!='0'?'color:green ' :'color:red'"
                      v-for="(item1,index) in billingTableData"
                      :key="index"
                    >
                      <td>{{index+1}}</td>
                      <td
                        :style="item1.TallyResponse==''?'color:red':item1.LINEERROR=='' && item1.CREATED!='0'?'color:green ' :'color:red'"
                        class="showMoreData"
                        @click="getBillData(item1)"
                      >{{item1.BillingSeries}}</td>
                      <td>
                        {{item1.clientName}}
                        <br>
                        <b-badge v-if="item1.invoiceForClient=='2'">Overseas Agent</b-badge>
                      </td>
                      <td>{{item1.jobType}}</td>
                      <td>{{item1.TallyResponse==''?'Failed To connect to Tally':item1.LINEERROR=='' && item1.CREATED!='0'?'DATA ADDED SUCCESSFULLY IN TALLY ' :item1.LINEERROR}}</td>
                      <td>
                        <md-icon
                          :style="item1.TallyResponse==''?'color:red':item1.LINEERROR=='' && item1.CREATED!='0'?'color:green ' :'color:red'"
                          class="md-size md-accent"
                        >{{item1.TallyResponse==''?'clear':item1.LINEERROR=='' && item1.CREATED!='0'?'done_outline' :'clear'}}</md-icon>
                      </td>

                      <td>
                        On {{item1.loginTime}}
                        <br>
                        By {{item1.employeeName}}
                        <br>
                        At {{item1.billingLocationName}}
                      </td>

                   <td> 
              <a
                  v-if="item1.dataPdf"
                  :href="`${docURL}/TALLY_PDF/`+item1.dataPdf"
                  target="_blank"
                  download
                >View PDF</a>

                     </td>
                    </tr>
                  </tbody>
                </table>
          
              </div>

              <!-- /.box-body -->
            </div>
            <div v-if="showMoreNewItem==false || billingTableData.length==0">
<div  v-if="mainExecutionDetails.length>0 && mainExecutionDetails[0].jobType">
<span><b>Execution Invoice</b><br></span>
              <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('FF')" 
                >FF  :- {{mainExecutionDetails[0].ffInvoiceClosed=='1'?'Received':'Not-Received'}}<br></span>
   <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('CC')" 
                >CC  :- {{mainExecutionDetails[0].ccInvoiceClosed=='1'?'Received':'Not-Received'}}<br></span>
   <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('TPT')" 
                >TPT  :- {{mainExecutionDetails[0].tptInvoiceClosed=='1'?'Received':'Not-Received'}}</span>

    <span
                v-if="mainExecutionDetails[0].jobType.split(',').includes('MISC')" 
                >MISC  :- {{mainExecutionDetails[0].miscInvoiceClosed=='1'?'Received':'Not-Received'}}</span>
</div>
              <!-- /.box-body v-if="showMoreNewItem==true" -->
              <md-layout md-gutter class="gutr" v-if="ffInvoiceModal.billingId==''">
                <md-layout md-flex="90" md-flex-small="100">
                 
                  <md-layout md-flex-small="100">
                    <md-layout
                      v-for="(segmentNameArray, index) in showSegmentArray"
                      :key="index"
                      :md-flex="segmentNameArray.flex"
                      md-flex-small="100"
                    >
                      <!-- :disabled="ffExoprtDetail.allModuleId!=''?true:false" -->
                      <md-checkbox
                        v-model="ffInvoiceModal.jobType[index]"
                        class="md-primary"
                        :md-value="segmentNameArray.value"
                        :name="'jobType'+(index+1)"
                        :id="'jobType'+(index+1)"
                        @change="jobTypeSelect(segmentNameArray.value,index)"
                      >
                        <b>{{segmentNameArray.show}}</b>
                      </md-checkbox>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>

              <div>


                <md-layout md-gutter class="gutr">
                
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <label>Job No.</label>
                      <b-form-input :formatter="capitalizeAll"
                        
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.jobNo"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
  <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Employee Billing Branch</label>
                    <model-list-select
isDisabled
                      @input="getBillingBranch"
                      :list="billingLocationData"
                      v-model="ffInvoiceModal.billingLocationId"
                      option-value="billingLocationId"
                      option-text="billingLocation"
                      placeholder="Select Billing Location"
                    ></model-list-select>
                 
                  </md-layout>
                </md-layout>
                  <!-- <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label for="containerTypeId">Billing Status</label>
                    <model-list-select
                      :list="invoiceStatusList"
                      v-model="ffInvoiceModal.billingStatus"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select Status"
                    ></model-list-select>
                  </md-layout> -->
                  <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="45">
              <md-layout md-flex="100">
                <label>Date</label>
                <b-form-input :formatter="capitalizeAll"
                  id="clientName"
                  disabled
                  name="clientName"
                  v-model="ffInvoiceModal.invDate"
                ></b-form-input>
              </md-layout>
                  </md-layout>-->
                </md-layout>
                <md-layout md-gutter class="gutr">

 
                </md-layout>

                <md-layout md-gutter class="gutr">
                <div class="mr-4">
<label style="    width: 44px;"> Other Clients</label>
    <b-form-checkbox style="padding-top: 0px" v-model="otherClientChecked" name="check-button" switch>
 
    </b-form-checkbox>
  </div>
 
                  <md-layout md-flex="20" v-if="mainExecutionDetails.length>0 && mainExecutionDetails[0].clientType=='3'">
                    <label for="containerTypeId">Invoice For</label>
                    <model-list-select
                    @input="changeClient"
                      :list="clientTypeList"
                      v-model="ffInvoiceModal.invoiceForClient"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5" v-if="mainExecutionDetails.length>0 && mainExecutionDetails[0].clientType=='3'" ></md-layout>
  <md-layout md-flex="45" >
                    <label for="containerTypeId">Client Name</label>
                    <model-list-select
:isDisabled="otherClientChecked==false?true:false"
                    @input="changeOtherClient"
                      :list="clientData"
                      v-model="ffInvoiceModal.clientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <!-- <md-layout md-flex="50" >
                    <md-layout md-flex="100">
                      <label>Client Name</label>
                      <b-form-input :formatter="capitalizeAll"
disabled
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.clientName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>  -->
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Client Contact</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.contact"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout md-gutter class="gutr">
               
                  <md-layout md-flex="50">
                    <md-layout md-flex="100">
                      <label>Client GSTN</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.clientgst"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>State</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.stateName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr">
                 
                  <md-layout md-flex="100">
                    <md-layout md-flex="100">
                      <label>Client Address</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.adress"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <div>
                  <md-layout md-gutter class="gutr">
                 
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Pickup Location</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.pickup"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Handover Location</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.Handover"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Factory Location</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.factoryLoc"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>GRN No.</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.grnNo"
                        ></b-form-input>
                      </md-layout>
                    </md-layout> -->
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                   
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Place Of Receipt</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.POR"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Load Port</label>
                        <b-form-input :formatter="capitalizeAll" id="clientName" name="clientName" v-model="ffInvoiceModal.LP"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Port Of Discharge</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.POD"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Final Place of Delivery</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.FPOD"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Shipping Bill No/ Date</label>
                         <b-form-textarea :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.BOE"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>BL No</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.blNo"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout> 
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Shipper Invoice No.</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          id="clientRegistrationNo"
                          name="clientRegistrationNo"
                          v-model="ffInvoiceModal.shipperInvNo"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Shipper Invoice Date</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          id="clientRegistrationNo"
                          name="clientRegistrationNo"
                          v-model="ffInvoiceModal.shipperInvDate"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Vessel / Voyage</label>
                         <b-form-textarea :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.vessel"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Weight (KGS)</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.weight"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                  
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Shipping Line Name</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.shippingLine"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
 
              
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>Other Charges</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.otherChargeFF"
                      ></b-form-textarea>
                    
                  </md-layout>
                </md-layout>
                  </md-layout>
                  <md-layout
                    md-gutter
                    class="gutr"
                    v-if="ffInvoiceModal.billingId!='' && ffInvoiceModal.containerDetails!=''"
                  >
                 
                    <md-layout md-flex="50">
                      <md-layout md-flex="100">
                        <label>Freight Container No.</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          disabled
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.containerDetails"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="45">
                      <md-layout md-flex="100">
                        <label>Freight Container Type</label>
                        <b-form-textarea :formatter="capitalizeAll"
                          disabled
                          id="clientName"
                          name="clientName"
                          v-model="ffInvoiceModal.multipleContainerType"
                        ></b-form-textarea>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <!--  && tallyTableData[0].airOrSea!='1' -->
                  <div class="gutr">
                    <b-card
                      v-if="ffInvoiceModal.containerDetails.length>0 && ffInvoiceModal.billingId==''"
                    >
                      <md-layout md-gutter v-if="shipmentType== '1'">
                      
                        <md-layout md-flex="40">
                          <label>
                            <u>Freight Container Details</u>
                          </label>
                        </md-layout>
                      </md-layout>

                      <md-layout
                        md-gutter
                        class="gutr"
                        v-for="(item, index) in ffInvoiceModal.containerDetails"
                        :key="index"
                      >
                        <md-layout md-flex="10" style="margin-bottom:20px;padding-top:50px">
                          <md-layout md-flex="100">
                            <b-button
                              @click="removeFFContainer(index,item)"
                              variant="info"
                              size="sm"
                            >Remove</b-button>
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="25" v-if="shipmentType== '1'">
                          <md-layout md-flex="100">
                            <label>Container No.</label>
                            <b-form-textarea :formatter="capitalizeAll"
                              disabled
                              class="gutr"
                              :key="index"
                              id="clientRegistrationNo"
                              name="clientRegistrationNo"
                              :value="item.containerNoFF"
                            ></b-form-textarea>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5" v-if="shipmentType== '1'"></md-layout>
                        <md-layout md-flex="25" v-if="shipmentType== '1'">
                          <md-layout md-flex="100">
                            <label>Container Type</label>
                            <b-form-textarea :formatter="capitalizeAll"
                              disabled
                              class="gutr"
                              id="clientRegistrationNo"
                              name="clientRegistrationNo"
                              :value="item.containerTypeFF"
                            ></b-form-textarea>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="15">
                          <md-layout md-flex="100">
                            <label>Assignment No.</label>
                            <b-form-textarea :formatter="capitalizeAll"
                              disabled
                              class="gutr"
                              id="clientRegistrationNo"
                              name="clientRegistrationNo"
                              :value="item.jobNo"
                            ></b-form-textarea>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5" style="margin-bottom:20px;padding-top:50px">
                          <md-layout md-flex="10">
                            <b-button
                              v-if="item.billingToTallDoneff==1"
                              disabled
                              variant="warning"
                              size="sm"
                            >Billing Done</b-button>
                          </md-layout>
                        </md-layout>

                        <!-- <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <b-form-input :formatter="capitalizeAll"
                    class="gutr"
                    v-for="(item3, index) in ffInvoiceModal.multiConNo"
                    :key="index"
                    id="clientRegistrationNo"
                    name="clientRegistrationNo"
                    :value="item3"
                  ></b-form-input>
                </md-layout>
                        </md-layout>-->
                      </md-layout>
                    </b-card>

                    <b-container
                      class="gutr"
                      v-if="ffInvoiceModal.containerDetailsCC.length>0 && ffInvoiceModal.billingId==''"
                    >
                      <b-card style="background:whiteSmoke">
                        <md-layout md-gutter>
                          <md-layout md-flex="30">
                            <label>
                              <u>Custom Container Details</u>
                            </label>
                          </md-layout>
                        </md-layout>

                        <md-layout
                          md-gutter
                          class="gutr"
                          v-for="(item, index) in ffInvoiceModal.containerDetailsCC"
                          :key="index"
                        >
                          <!-- <md-layout md-flex="10" style="margin-bottom:20px;padding-top:50px">
                            <md-layout md-flex="100">
                              <b-button
                                v-if="item.billingToTallDoneff==1"
                                disabled
                                variant="warning"
                                size="sm"
                              >Billing Done</b-button>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="10" style="margin-bottom:20px;padding-top:50px">
                            <md-layout md-flex="100">
                              <b-button
                                @click="removeFFContainer(index,item)"
                                variant="info"
                                size="sm"
                              >Remove</b-button>
                            </md-layout>
                          </md-layout>-->
                          <md-layout md-flex="50">
                            <md-layout md-flex="100">
                              <label>Container No.</label>
                              <b-form-textarea :formatter="capitalizeAll"
                                disabled
                                class="gutr"
                                :key="index"
                                id="clientRegistrationNo"
                                name="clientRegistrationNo"
                                :value="item.containerNoFF"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="40">
                            <md-layout md-flex="100">
                              <label>Container Type</label>
                              <b-form-textarea :formatter="capitalizeAll"
                                disabled
                                class="gutr"
                                id="clientRegistrationNo"
                                name="clientRegistrationNo"
                                :value="item.containerTypeFF"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>
                          <!-- <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="15">
                            <md-layout md-flex="100">
                              <label>Assignment No.</label>
                              <b-form-textarea :formatter="capitalizeAll"
                                disabled
                                class="gutr"
                                id="clientRegistrationNo"
                                name="clientRegistrationNo"
                                :value="item.jobNo"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>-->
                        </md-layout>
                      </b-card>
                    </b-container>
                   
                      <b-card class="mt-3" style="background:whiteSmoke" v-if="TPTGRNDATA.length>0">
                        <div class="box gutr">
                          <div class="box-body gutr">
                         <h5>   <b-badge>TPT Annexure Details</b-badge></h5>
                            <table id="quotationDetail" class="table table-striped gutr">
                              <thead>
                                <tr>
                                  <th>GRN Number</th>
                                  <th>Container Number & Type</th>
                                  <th>Fuel Slip No.</th>
                                  <th>Vehicle No</th>
                                  <th>S-Line Seal No.</th>
                                  <th>Custom Seal No.</th>
                                  <th>Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in TPTGRNDATA" :key="index">
                                  <td>
                                    {{item.GRNSeries}}
                                    <br>
                                    <b-button
                                      disabled
                                      variant="warning"
                                      size="sm"
                                      v-if="item.billingToTallDone==1"
                                    >Billing Done</b-button>
                                    <br>
                                    <br>
                                    <b-button
                                      disabled
                                      variant="warning"
                                      size="sm"
                                      v-if="item.invoiceStatus!=0"
                                    >Invoice Pending From TPT</b-button>
                                    <br>
                                    <br>

                                    <b-button
                                      variant="info"
                                      size="sm"
                                      @click="removeGRN(index,item)"
                                    >Remove</b-button>
                                  </td>

                                  <td>
                                    {{item.containerNo}}
                                    <br>
                                    {{item.multipleContainerType}}
                                  </td>
                                  <td>{{item.FuelSlipNo}}</td>
                                  <td>{{item.vehicleNo}}</td>
                                  <td>{{item.slineSealNo}}</td>
                                  <td>{{item.customSealNo}}</td>
                                  <td>
                                    <span>Loading Date :{{item.Date | moment}}</span>
                                    <br>
                                    <span>Reporting Date :{{item.factoryInDate | moment}}</span>
                                    <br>
                                    <span>Released Date :{{item.factoryOutDate | moment}}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </b-card>
                
                  </div>

                  <!-- <md-layout md-gutter class="gutr">
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="90">
                    <md-layout md-flex="100">
                      <label>Port Charges Details</label>
                      <b-form-textarea :formatter="capitalizeAll"
                        id="PortAdditionalCharges"
                        name="PortAdditionalCharges"
                        v-model="ffInvoiceModal.PortAdditionalCharges"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  </md-layout>-->
                </div>
               
              </div>
            </div>
                   </b-card-text>
        </b-card>
            <div
            class="mt-2"
           
              v-if="showMoreNewItem==false || ffInvoiceModal.billingId!='' || billingTableData.length==0"
            >
             <b-form-checkbox v-if="ffInvoiceModal.billingId!='' && mainExecutionDetails[0].finalBillingCompleted=='0' &&  mainExecutionDetails.length > 0 " size="lg"  @change="copyCharges" value="notSelected" v-model="selectedTallyInv">Select to Update Charges Details</b-form-checkbox>
          

             <div >

                       <h5> <b-badge   >CHARGES</b-badge></h5>    
              <table id="quotationDetail" class="table table-responsive-lg  mt-3 table-light  table-bordered ">
                
                <tbody>
                      <tr>
                    <th style="width:45px">
                      <b-button
                      v-if="ffInvoiceModal.billingId==''"
                 size="sm"
                 variant="light"
                      
                        @click="addQuotationFields"
                      >
                        <!-- @click="addQuotationFields" -->
                     <md-icon md-va>add</md-icon>
                      </b-button>
<br><br>

      <b-form-checkbox
     v-model="slectedAllStatus"

   class="ml-2"
      value="1"
      unchecked-value="0" 
    
 @input="SelectedAll"
   
    
    > 
</b-form-checkbox>              

                    </th>

                    <th style="width:170px">  <span>Particulars *</span></th>
                   
                    <th v-if="shipmentType== '1'">  <span >Container Type</span></th>
                    <th style="width: 82px;">  <span>Quantity *</span></th>
 <th>  <span>Currency *</span></th>
  <th style="width: 130px;">      <span>Quotation Rate *</span></th>
                    <th style="width: 130px;"> <span>Selling Rate *</span></th>
                    <th style="width: 100px;"> <span>Exch Rate *</span></th>
                  
                    <th style="width: 130px;"> <span>Final Amount *</span></th>
                  
                 
                   
                   
 <th>    <span>Unit *</span></th>
                    <th>   <span>Remarks</span></th>
                 
                   
                  </tr>
                  <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                    <td >
<b-form-checkbox
     
      v-model="item.slectedStatus"
class="mt-3 ml-2"
   
      value="1"
      unchecked-value="0"
    >
</b-form-checkbox> 
                      <!-- <b-button
                  
                      size="sm"
                      variant="danger"
                        v-if="ffTallyInvoiceData.length>1 &&  ffInvoiceModal.billingId==''"
                    
                        @click="removeCol(index)"
                      
                      >
                       Remove
                      </b-button> -->
                    </td>
                    <!-- <td>{{index+1}}</td> 
                    :isDisabled="item.mainffId!=''?true:false"-->
                    <td>
                     
                      <model-list-select
class="parti"
                        :list="ledgerData"
                        @input="getDuplicateLedger(item,index)"
                        v-model="item.ffType"
                        option-value="ledger"
                        option-text="ledger"
                      
                      ></model-list-select>

                    </td>
<td v-if="shipmentType== '1'">
                      
                        <model-list-select
                        v-if="shipmentType== '1'"
                        :list="containerMasterData"
                        v-model="item.containerType"
                        option-value="containerType"
                        option-text="containerType"
                      
                      ></model-list-select>
                      <!-- <b-form-input :formatter="capitalizeAll" :disabled="item.mainffId!=''?true:false" v-model="item.ffType"></b-form-input> -->
                    </td>
                    <!-- :isDisabled="item.mainffId!=''?true:false" -->
                  

                    <td>
                    
                      <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)" type="number" v-model="item.quantity"></b-form-input>
                    </td>
<td>
                    
                        <model-list-select
                        :list="currencyList"
                        v-model="item.currency"
                        option-value="currencyV"
                        option-text="currencyT"
                      
                      ></model-list-select>
                    </td>
<td>
                     
                      <b-form-input :formatter="capitalizeAll"  :disabled=item.ffSellingRate?true:false @input="getFinalAmount(index)"  type="number" v-model="item.ffSellingRate"></b-form-input>
                     
                    </td>

                    <!-- :disabled="item.mainffId!=''?true:false" -->
                    <td>
                     
                     
                       <b-form-input :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      
                        type="number"
                        v-model="item.sellingRateFinal"
                      ></b-form-input></td>

                    <!-- :disabled="item.ffSellingRate==''?true:false" -->
                   
                 <td>
                     
                      <b-form-input :formatter="capitalizeAll" @input="getFinalAmount(index)"  type="number" v-model="item.exchRate"></b-form-input>
                     
                    </td>  
                    <td>
                     
                      <b-form-input :formatter="capitalizeAll"   type="number" v-model="item.invAmount"></b-form-input></td>


<td>
                   
                       <model-list-select
                        :list="unitList"
                        v-model="item.unit"
                        option-value="unitId"
                        option-text="unitName"
                      
                      ></model-list-select></td>
                    <!-- :isDisabled="item.mainffId!=''?true:false" -->
                   
                    <td>
                   
                      <b-form-textarea :formatter="capitalizeAll"  v-model="item.remark"></b-form-textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
             </div>

              <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label>Job No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="clientName"
                  name="clientName"
                  v-model="ffInvoiceModal.chnageApprovalStatus"
                ></b-form-input>
              </md-layout>
            </md-layout>
              </md-layout>-->
              <md-layout md-gutter class="mrgtop-2per gutr mt-5">
                <md-layout md-flex="35"></md-layout>
                <md-layout md-flex="30">
                  <b-button
                    block
                    v-if=" ffInvoiceModal.billingId==''"
                    variant="primary"
                    @click="addDataTally"
                    id="addButtonLoader"
                  >{{ffInvoiceModal.billingId!=''?'Update':'Send Data To Tally'}}</b-button>
                  <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                </md-layout>
                <md-layout md-flex="20"></md-layout>
                <!-- <md-layout md-flex="15">
                  <b-button
                
                    v-if="validateTally==true"
                    variant="dark"
                   
                    @click="quoteChangeApproval('2')"
                  >Send For Approval</b-button>
                </md-layout> -->
              </md-layout>
            </div>
   
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopMaxPer"></md-dialog-alert>
 <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
 <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose"
    ></md-dialog-confirm>
 <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="submitInvoice"
      ref="addPopTally"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {

    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/freightInvoiceForTally"
      );

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      billingLocationData: [],
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      invoiceStatusList: [
        {
          inv: "0",
          int: "In-Complete",
        },
        {
          inv: "1",
          int: "Completed",
        },
      ],
      showMoreNewItem: true,
      selectedTallyInv: "",
      selectedAllModuleId: "",
      showBill: false,
      ccInvoiceTallyData: [],
      tallyTableData: [],
      validateTally: false,
      unitList: [
      
      ],
  docURL: URL_BASE_DOC,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],

      isLoading: false,
      containerNoName: [],
      TPTInvoiceTallyData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      CCCheckDone: 0,
      ffCheckDone: 0,
      TPTCheckDone: 0,
      miscCheckDone: 0,
      ledgerData: [],
      clientData: [],
      TPTGRNDATA: [],
      TOLLPRICE: "",
      shipmentType: "",
      billingTableData: [],
      containerMasterData: [],
      mainExecutionDetails: [],
      jobTypeSelectVal: false,
      showSegmentArray: [],
      clientTypeList: [
        {
          inv: "1",
          int: "Client",
        },
        {
          inv: "2",
          int: "Oversea Agent",
        },
      ],
      cTypeList: [
        {
          inv: "1",
          int: "Client",
        },
      ],
      overTypeList: [
        {
          inv: "2",
          int: "Oversea Agent",
        },
      ],
      showOverSea: false,
      selectedValue: "",
      clist: false,
slectedAllStatus:"0",
otherClientChecked:false,
      ffInvoiceModal: {
fromAgentColoderTable:"N",
manualBilling:"0",
       tallyBillingSeries:1,
        billingStatus: "0",
        invoiceForClient: "",
        acutalclientForOverSea: "",
        otherChargeFF: "",
        BILLDONE: [],
        FFtallyId: [],
        billingLocationId: "",
        billingLocationName: "",
        shipperInvNoforTally: "",
        shipperInvDateforTally: "",
        shipperInvNo: "",
        shipperInvDate: "",
        stateName: "",
        clientgst: "",
        TOLCHRG: "",
        TPTCHARGES: "",
        secondFF: "",
        multiTPT: "",
        grnNo: "",
        pickup: "",
        Handover: "",
        factoryLoc: "",

        jobType: [],
        jobTypeName: [],
        chnageApprovalStatus: "",
        billingId: "",
        invDate: "",
        jobNo: "",
        sentForRevisedApproval: "",
        revisedActionTakenFromMail: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        BOE: "",
clientId:"",
        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetails: [],
        containerDetailsCC: [],
        multipleContainerType: [],
        multiConNo: [],
        shippingLine: "",
      },
      newJobType: [],
      disableJobType: [],
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      ccContainers: [],
      ffContainers: [],
      revisedSavedBillingData: [],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {},
  methods: {
  closeBill(id) {
this.selectedAllModuleId=id

      this.alert.content =
        "Are you sure to close Assignment Billing ?";
      this.$refs["addPopClose"].open();
    },
closeBillOk(type){
   if (type != "cancel") {
this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
       
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.getData();
              this.isLoading = false;
            }
          })
          .catch(error => {});
   }

},
 changeOtherClient() {
      let arryDone = this.clientData.filter(x => {
        return x.clientId == this.ffInvoiceModal.clientId;
      });
      if(arryDone.length>0){

       this.ffInvoiceModal.clientName=arryDone[0].clientName
       this.ffInvoiceModal.contact=arryDone[0].phoneKYC
       this.ffInvoiceModal.clientgst=arryDone[0].gstCode + arryDone[0].GSTN
       this.ffInvoiceModal.stateName=arryDone[0].stateName 
       this.ffInvoiceModal.adress=arryDone[0].corporateAddress 
   this.ffInvoiceModal.fromAgentColoderTable=arryDone[0].fromAgentColoderTable 

      }
if(this.mainExecutionDetails.length>0){
if(this.mainExecutionDetails[0].clientId && (this.mainExecutionDetails[0].clientId==this.ffInvoiceModal.clientId || this.mainExecutionDetails[0].exporterClientId==this.ffInvoiceModal.clientId ))
this.otherClientChecked=false
}
    //  this.ffInvoiceModal.jobNo="-/-/" + this.UserDetailForBillingLoc[0].BranchCode   
    },
 getAddedBillingBranchInv() {
    let payload={
        billingLocationId:this.ffInvoiceModal.billingLocationId
            }

        let options = {
          method: "PUT",
          url: `${URL_BASE}/Api_TallyBilling/getExistingTallyData.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
   if ( status == 200 && data) {
console.log(data)
if(data.existingBillingLocationData.length>0){ 
this.ffInvoiceModal.tallyBillingSeries=parseInt(data.existingBillingLocationData.length);
   }else{
this.ffInvoiceModal.tallyBillingSeries=1;
}
   }
            // $("#loaderS").css("display", "none");
            // $("#addButtonLoaderS").css("display", "block");
   
            // this.getData();
            // this.$router.push({
            //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
            // });
          })
          .catch((error) => {});
      
    },

    getBillingBranch() {
      let arryNewBillBranch = this.billingLocationData.filter((x) => {
        return x.billingLocationId == this.ffInvoiceModal.billingLocationId;
      });


      if (arryNewBillBranch.length > 0) {
        this.ffInvoiceModal.billingLocationId =
          arryNewBillBranch[0].billingLocationId;
        this.ffInvoiceModal.billingLocationName =
          arryNewBillBranch[0].billingLocation;


      }
// this.getAddedBillingBranchInv();
    },
    copyCharges() {
      if (this.selectedTallyInv == false) {
        this.showMoreItem();
      }
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          allModuleId: this.ffInvoiceModal.allModuleId,
          approvalMail: "approvalMail",
          executionNo: this.ffInvoiceModal.jobNo,
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/sendApprovalRevisedBilling.php`,
            data: JSON.stringify(newData),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.getData();
              //this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    openPop() {
      if (this.ffInvoiceModal.sentForRevisedApproval == "1") {
        this.confirm.contentHtml = "Already Sent  for Approval..?";
      } else {
        this.confirm.contentHtml = "Send   for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    changeClient() {
      // let arryDone = this.billingTableData.filter(x => {
      //   return x.invoiceForClient == this.ffInvoiceModal.invoiceForClient;
      // });
      // if(arryDone.length>0){
      //   let contaierAdded=arryDone
      //   let particularsAdded=
      //   console.log(arryDone)
      //  this.ffTallyInvoiceData.map(x => {
      //         if (x.ffType == "TRANSPORT CHARGES") {
      //           this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
      //         }
      //         if (x.ffType == "TOLL CHARGES") {
      //           this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
      //         }
      //         let dummy = parseInt(x.invAmount) + total;
      //         total = dummy;
      //       });
      // }

      if (this.ffInvoiceModal.invoiceForClient == "1") {

        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].exporter;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].exporterClientId;

  // this.ffInvoiceModal.contact=arryDone[0].phoneKYC
  //      this.ffInvoiceModal.clientgst=arryDone[0].gstCode + arryDone[0].GSTN
  //      this.ffInvoiceModal.stateName=arryDone[0].stateName 
  //      this.ffInvoiceModal.adress=arryDone[0].corporateAddress 
      } else {

        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].clientName;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].clientId;
      }
    },
    reload() {
      // Object.keys(this.ffInvoiceModal).map(x => {
      //   this.ffInvoiceModal[x] = "";
      // });
    },
    showMoreItem() {
      Object.keys(this.ffInvoiceModal).map((x) => {
        this.ffInvoiceModal[x] = "";
      });
      this.getData();

      this.newJobType = [];
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },
    goToMain() {
      this.ffInvoiceModal.billingId = "";
    },
    getDuplicateLedger(item,index) {
//  var x = document.getElementsByClassName("parti")[index];
// var y=x.getElementsByClassName("text");
// // y[0].outerHTML=""
// y[0].outerText=item.ffType
// console.log(x,"jhhhhhhhhhhhhhh",y[0].outerText)
      // let alreadyLedger = item.ffType;
      // let array = this.ffTallyInvoiceData.filter((x) => {
      //   return x.ffType == alreadyLedger;
      // });

      // if (array.length > 1) {
      //   this.alert.content = alreadyLedger + " Already Exists..! ";
      //   this.$refs["addPopMaxPer"].open();
      // }
    },
    getBillData(item) {
      this.ffInvoiceModal.billingId = item.billingId;
      this.showMoreNewItem = true;
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });

      let CCParti = [];
      let CCCon = [];
      let CCSellingR = [];
      let CCSF = [];
      let CCInvAmt = [];
      let exchRateArry = [];
      let CCCurrency = [];
      let CCQuantity = [];
      let CCRemark = [];
      let UN = [];

      if (item.particulars != null) {
        CCParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        CCCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        CCQuantity = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        CCSellingR = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        CCSF = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.finalRateWithoutTax != null) {
        CCInvAmt = item.finalRateWithoutTax.split(",");
      }
if (item.exchRate) {
        exchRateArry = item.exchRate.split(",");
      }
      if (item.currency != null) {
        CCCurrency = item.currency.split(",");
      }
      if (item.remark != null) {
        CCRemark = item.remark.split(",");
      }
      if (item.containerDetails != null) {
        this.ffInvoiceModal.containerDetails = item.containerDetails.split(",");
      }
      if (item.multipleContainerType != null) {
        this.ffInvoiceModal.multipleContainerType = item.multipleContainerType.split(
          ","
        );
      }

      if (CCParti.length > 0) {
        CCParti.map((x, index) => {
          let obj1 = {
            ffType: x,
            containerType: CCCon[index],
            quantity: CCQuantity[index],
            ffSellingRate: CCSellingR[index],
            exchRate: exchRateArry.length>0?exchRateArry[index]:'1',
            sellingRateFinal: CCSF[index],
            unit: UN[index],
            invAmount: CCInvAmt[index],
            currency: CCCurrency[index],
            remark: CCRemark[index],
 slectedStatus: "0",
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });

        this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    getAllTallyData() {
      this.ffTallyInvoiceData = [];
      this.TPTGRNDATA = [];
      this.ffInvoiceModal.containerDetails = [];
      this.ffInvoiceModal.containerDetailsCC = [];
      this.isLoading = true;
      let vehicle_drive = {
        allModuleId: this.ffInvoiceModal.allModuleId,
        itemCode: "itemCode",
        jobType : this.newJobType,
        ccCheck: this.newJobType.indexOf("CC"),
        tptCheck: this.newJobType.indexOf("TPT"),
        ffCheck: this.newJobType.indexOf("FF"),
        miscCheck :this.newJobType.indexOf("MISC"),
        CCCheckDone: this.CCCheckDone,
        ffCheckDone: this.ffCheckDone,
        TPTCheckDone: this.TPTCheckDone,
         miscCheckDone: this.miscCheckDone,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/fetchAllInvoiceTallyData.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            let CON_NO = [];
            let CONTYPE = [];
            // For CC
            if (this.newJobType.indexOf("CC") >= 0) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.ccInvoiceTallyData.length > 0) {
                this.ccInvoiceTallyData = data.ccInvoiceTallyData;
                this.ffInvoiceModal.POR = this.ccInvoiceTallyData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.ccInvoiceTallyData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.ccInvoiceTallyData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.ccInvoiceTallyData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
// console.log(,"tuiyi")
// if(this.selectedValue=='FF'){ 
// this.ffInvoiceModal.shipperInvNo="";
// this.ffInvoiceModal.shipperInvDate="";
// this.ffInvoiceModal.BOE="";
// this.ffInvoiceModal.blNo="";
// this.ffInvoiceModal.vessel="";
// this.ffInvoiceModal.vessel="";
// this.ffInvoiceModal.weight="";
// }
if(!this.newJobType.includes('FF')){ 

this.ffInvoiceModal.shipperInvNo =this.ccInvoiceTallyData[0].shipperInvNo;

this.ffInvoiceModal.shipperInvNoforTally =this.ccInvoiceTallyData[0].shipperInvNo

this.ffInvoiceModal.shipperInvDateforTally =this.ccInvoiceTallyData[0].shipperInvDate
 this.ffInvoiceModal.shipperInvDate=this.ccInvoiceTallyData[0].shipperInvDate;
this.ffInvoiceModal.BOE =this.ccInvoiceTallyData[0].BOE;

this.ffInvoiceModal.blNo =this.ccInvoiceTallyData[0].blNo;

this.ffInvoiceModal.vessel =this.ccInvoiceTallyData[0].vessel;

this.ffInvoiceModal.weight =this.ccInvoiceTallyData[0].weight;
this.ffInvoiceModal.shippingLine = this.ccInvoiceTallyData[0].shippingLine;

this.ffInvoiceModal.otherChargeFF = this.ccInvoiceTallyData[0].PortAdditionalCharges;
}

                CCParti = this.ccInvoiceTallyData[0].particulars.split(",");
                CCCon = this.ccInvoiceTallyData[0].containerType.split(",");
                CCQuantity = this.ccInvoiceTallyData[0].quantity.split(",");
                CCSellingR = this.ccInvoiceTallyData[0].quotationRate.split(
                  ","
                );
                CCSF = this.ccInvoiceTallyData[0].sellingRateFinal.split(",");
if(this.ccInvoiceTallyData[0].exchRate){ 
                EXRTCC = this.ccInvoiceTallyData[0].exchRate.split(",");
}else{
EXRTCC=[]
}
                CCInvAmt = this.ccInvoiceTallyData[0].finalRateWithoutTax.split(
                  ","
                );
                CCCurrency = this.ccInvoiceTallyData[0].currency.split(",");
                UN = this.ccInvoiceTallyData[0].unit.split(",");

                CCRemark = this.ccInvoiceTallyData[0].remark.split(",");
                if (
                  this.ffInvoiceModal.containerDetailsCC.length !=
                  this.ccInvoiceTallyData.length
                ) {
                  let CCContainerTable = {
                    // FFInvIdId: this.ccInvoiceTallyData[r].InvTallyId,
                    // billingToTallDoneff: this.ccInvoiceTallyData[r] .billingToTallDoneff,
                    containerNoFF: this.ccInvoiceTallyData[0].containerDetails,
                    containerTypeFF: this.ccInvoiceTallyData[0]
                      .multipleContainerType,
                  };

                  // console.log(FFContainerTable);
                  this.ffInvoiceModal.containerDetailsCC.push(CCContainerTable);
                }

                // CON_NO = this.ccInvoiceTallyData[0].containerDetails.split(",");
                // CONTYPE = this.ccInvoiceTallyData[0].multipleContainerType.split(
                //   "," );
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                  exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
 slectedStatus: "0",
                  };

                  this.ffTallyInvoiceData.push(obj1);

                  // this.CCCheckDone = 1;
                });
              }
            }

            // For FF
            if (this.newJobType.indexOf("FF") >= 0) {
              let TParti = [];
              let TCon = [];
              let TSelO = [];
              let TSF = [];
              let TINV = [];
              let TCUR = [];
              let TRE = [];
              let QUN = [];
              let FFINVID = [];
              let UNF = [];
              let EXRTFF = [];

              if (data.tallyTableData.length > 0) {
                this.tallyTableData = data.tallyTableData;

                this.ccInvoiceTallyData = data.ccInvoiceTallyData;
this.ffInvoiceModal.shipperInvNoforTally =this.tallyTableData[0].shipperInvNo
this.ffInvoiceModal.shipperInvDateforTally =this.tallyTableData[0].shipperInvDate
this.ffInvoiceModal.shipperInvNo =this.tallyTableData[0].shipperInvNo;

 this.ffInvoiceModal.shipperInvDate=this.tallyTableData[0].shipperInvDate;
this.ffInvoiceModal.BOE =this.tallyTableData[0].BOE;

this.ffInvoiceModal.blNo =this.tallyTableData[0].blNo;

this.ffInvoiceModal.vessel =this.tallyTableData[0].vessel;

this.ffInvoiceModal.weight =this.tallyTableData[0].weight;
this.ffInvoiceModal.shippingLine = this.tallyTableData[0].shippingLine;

// console.log(this.tallyTableData,"iuyyghjkh")


  
                this.ffInvoiceModal.POR = this.tallyTableData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.tallyTableData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.tallyTableData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.tallyTableData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                
                for (let r = 0; r < this.tallyTableData.length; r++) {
                  FFINVID = this.tallyTableData[r].InvTallyId;
                  TParti = this.tallyTableData[r].particulars.split(",");
                  TCon = this.tallyTableData[r].containerType.split(",");
                  QUN = this.tallyTableData[r].quantity.split(",");
                  TSelO = this.tallyTableData[r].quotationRate.split(",");
                  TSF = this.tallyTableData[r].sellingRateFinal.split(",");
                  TINV = this.tallyTableData[r].finalRateWithoutTax.split(",");
                  TCUR = this.tallyTableData[r].currency.split(",");
                  TRE = this.tallyTableData[r].remark.split(",");
                  UNF = this.tallyTableData[r].unit.split(",");
if(this.tallyTableData[0].exchRate){ 
                  EXRTFF = this.tallyTableData[r].exchRate.split(",");
}else{
EXRTFF=[]
}
                  let FFContainerTable = {
                    FFInvIdId: this.tallyTableData[r].InvTallyId,
                    billingToTallDoneff: this.tallyTableData[r]
                      .billingToTallDoneff,
                    containerNoFF: this.tallyTableData[r].containerDetails,
                    containerTypeFF: this.tallyTableData[r]
                      .multipleContainerType,
                    jobNo: this.tallyTableData[r].jobNo,
                  };
                  // console.log(FFContainerTable);
                  this.ffInvoiceModal.containerDetails.push(FFContainerTable);

                  if (TParti.length > 0) {
                    TParti.map((y, index) => {
                      let obj = {
                        ffType: y,
                        containerType: TCon[index],
                        quantity: QUN[index],
                        ffSellingRate: TSelO[index],
                        exchRate: EXRTFF[index],
                      
                        sellingRateFinal: TSF[index],
                        unit: UNF[index],
                        invAmount: TINV[index],
                        currency: TCUR[index],
                        remark:
                          TINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TRE[index]
                            : TRE[index],
                        mainffId: FFINVID,
                         slectedStatus: "0",
                      };
                      this.ffTallyInvoiceData.push(obj);

                      // this.ffCheckDone = 1;
                    });
                  }

                  // if (
                  //   this.ffInvoiceModal.containerDetails.length !=
                  //   this.tallyTableData.length
                  // ) {
                  //   if (CON_NO.length > 0) {
                  //     this.ffInvoiceModal.containerDetails.push(CON_NO);
                  //   }
                  //   if (CONTYPE.length > 0) {
                  //     this.ffInvoiceModal.multipleContainerType.push(CONTYPE);
                  //   }
                  // }
                }
              }
            } else {
              this.ffCheckDone = 0;
            }

            // for TPT
            if (this.newJobType.indexOf("TPT") >= 0) {
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              //   let TCUR = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTInvoiceTallyData.length > 0) {
                this.TPTInvoiceTallyData = data.TPTInvoiceTallyData;
                this.ffInvoiceModal.pickup = this.TPTInvoiceTallyData[0].fromLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.Handover = this.TPTInvoiceTallyData[0].toLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.factoryLoc = this.TPTInvoiceTallyData[0].StuffingLocation.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                for (let p = 0; p < this.TPTInvoiceTallyData.length; p++) {
                  TPTParti = this.TPTInvoiceTallyData[p].particulars.split(",");
                  INVID = this.TPTInvoiceTallyData[p].invoiceId;
                  TPTCon = this.TPTInvoiceTallyData[p].containerType.split(",");
                  TPTQUN = this.TPTInvoiceTallyData[p].quantity.split(",");
                  UNT = this.TPTInvoiceTallyData[p].unit.split(",");
                  TPTSelO = this.TPTInvoiceTallyData[p].quotationRate.split(
                    ","
                  );
                  TPTSF = this.TPTInvoiceTallyData[p].sellingRateFinal.split(
                    ","
                  );
                  TPTINV = this.TPTInvoiceTallyData[
                    p
                  ].finalRateWithoutTax.split(",");
                  TPTRE = this.TPTInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0",
                      };
                      this.ffTallyInvoiceData.push(obj2);
                      //  this.tptCheckDone = 1;
                    });
                  }
                }
              }
            } else {
              this.tptCheckDone = 0;
            }
 


            if (data.TPTGRNDATA.length > 0) {
              this.TPTGRNDATA = data.TPTGRNDATA;
              this.TOLLPRICE = parseInt(data.TPTGRNDATA[0].tollPrice);
           
            }
          
            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    jobTypeSelect(value, index) {
this.selectedValue=value
      this.ffInvoiceModal.jobTypeName = this.newJobType;
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
      let selectedJob = this.newJobType.toString();
      if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("CC") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,CC,TPT" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,TPT" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("CC") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "CC,TPT" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("CC")
      ) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF,CC" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("FF")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "FF" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("CC")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "CC" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("TPT")) {
        let onlyFF = this.billingTableData.filter((x) => {
          return x.jobType == "TPT" && x.addedToTallySucessStatus=='1';
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.multiTPT = onlyFF.length;
        } else {
          this.ffInvoiceModal.multiTPT = "";
        }
      } else {
        console.log("no job");
      }

      this.getAllTallyData();
      // this.getData();
//this.getAddedBillingBranchInv();
    },
    getServicesData() {
      this.showSegmentArray = [];
      let jobArry = this.mainExecutionDetails[0].jobType.split(",");
      jobArry.map((x) => {
        let obj = {
          value: x,
          show:
            x == "FF"
              ? "Freight Forwarding(" + x + ")"
              : x == "CC"
              ? "Custom Clearance(" + x + ")"
              : x == "TPT"
              ? "Transportation(" + x + ")"
              : x == "MISC"
              ? "MISC(" + x + ")"
              : "",
          flex: "20",
        };
        this.showSegmentArray.push(obj);
      });
      // this.showSegmentArray = [
      //   {
      //     value: "FF",
      //     show: "Freight Forwarding(FF)",
      //     flex: "20"
      //   },
      //   {
      //     value: "CC",
      //     show: "Customs Clearance(CC)",
      //     flex: "20"
      //   }
      // ];
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });

      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }

      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );

      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    getFinalAmount(ind) {
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) * parseFloat(this.ffTallyInvoiceData[ind].exchRate);
      if (
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) <
        parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)
      ) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
      // this.ffTallyInvoiceData.map((x, index) => {
      //   if (x.quantity != "") {
      //     let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
      //     x.invAmount = finalAmt;
      //   }
      // });
    },
    addDataTally() {
 if (this.newJobType.length <= 0) {
        this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop"].open();
        return false;
      }
if (this.ffInvoiceModal.billingLocationId == "") {
          this.alert.content = "Please Select Billing Location";
          this.$refs["addPop"].open();
          return false;
        }


      this.alert.content =
        "Data will be added to " + this.ffInvoiceModal.billingLocationName;
      this.$refs["addPopTally"].open();
    },

    submitInvoice(type) {
      let id = "1";


      if (type != "cancel") {
 this.ffInvoiceModal.jobTypeName = this.newJobType;
       for (let t = 0; t < this.ffTallyInvoiceData.length; t++) {
if(!this.ffTallyInvoiceData[t].slectedStatus || this.ffTallyInvoiceData[t].slectedStatus=='0'){
this.ffTallyInvoiceData.splice(t,1);
}   }

        if (this.ffTallyInvoiceData.length > 0) {
          for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
if(!this.ffTallyInvoiceData[r].slectedStatus || this.ffTallyInvoiceData[r].slectedStatus=='0'){

this.ffTallyInvoiceData.splice(r,1);

  return false;
  break;
}else{ 

   if (
              !this.ffTallyInvoiceData[r].ffType  && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].quantity  && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].ffSellingRate && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].sellingRateFinal && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].unit && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].invAmount && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else if (
              !this.ffTallyInvoiceData[r].currency && this.ffTallyInvoiceData[r].slectedStatus=='1'
            ) {
              this.alert.content =
                "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              this.$refs["addPop"].open();
              return false;
              break;
            } else {
              console.log("All fields are Entered");
            }


          }


         
          }
        } else {
          this.alert.content = "Please Add minimum 1 Chagers to Tally";
          this.$refs["addPop"].open();
          return false;
          return false;
        }

        if (this.ffInvoiceModal.clientName == "") {
          this.alert.content = "Please Enter Client Name";
          this.$refs["addPop"].open();
          return false;
        }
        this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;

        this.ffInvoiceModal["TPTGRNDATA"] = this.TPTGRNDATA;
 if(!this.newJobType.includes('FF') && !this.newJobType.includes('CC')){
this.ffInvoiceModal.containerDetails=[];
        for (let k = 0; k < this.TPTGRNDATA.length; k++) {

let obj={
containerNoFF:this.TPTGRNDATA[k].containerNo,
containerTypeFF:this.TPTGRNDATA[k].multipleContainerType,
}
 this.ffInvoiceModal.containerDetails.push(obj);
} 
        }

        if (
          this.newJobType.indexOf("CC") >= 0 &&
          this.ffInvoiceModal.containerDetailsCC.length > 0
        ) {
          this.ffInvoiceModal.containerDetails = this.ffInvoiceModal.containerDetailsCC;
        }

        this.ffInvoiceModal["buttonId"] = id;
        let total = 0;

        this.ffTallyInvoiceData.map((x) => {
          if (x.ffType == "TRANSPORT CHARGES") {
            this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
          }
          if (x.ffType == "TOLL CHARGES") {
            this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
          }
          let dummy = parseFloat(x.invAmount) + total;
          total = dummy;
        });

        this.ffInvoiceModal.totalAmount = total;
this.ffInvoiceModal['manualBilling']="0";
if(this.otherClientChecked==true){
this.ffInvoiceModal['otherClientChecked']="Y";
}

 

        if (this.validateInvoice != false) {
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/addBillingTally_NewV3.php`,
            data: JSON.stringify(this.ffInvoiceModal),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };
          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if ( status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  this.alert.content = "Added Successfully";
                } else {
                  this.alert.content = "Data Updated Successfully";
                }
                $("#addButtonLoader").css("display", "block");
                $("#loader").css("display", "none");
                this.$refs["addPop"].open();
                this.getData(id);
this.slectedAllStatus="0"
                // this.showMoreNewItem = false;
                //   location.reload();
              }
            })
            .catch((err) => {
              throw err;
            });
        }
      }
    },

    quoteChangeApproval(id) {
      if (this.ffTallyInvoiceData.length > 0) {
        for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
          if (
            this.ffTallyInvoiceData[r].ffType == "" ||
            this.ffTallyInvoiceData[r].ffType == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].quantity == "" ||
            this.ffTallyInvoiceData[r].quantity == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].ffSellingRate == "" ||
            this.ffTallyInvoiceData[r].ffSellingRate == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].sellingRateFinal == "" ||
            this.ffTallyInvoiceData[r].sellingRateFinal == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].unit == "" ||
            this.ffTallyInvoiceData[r].unit == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].invAmount == "" ||
            this.ffTallyInvoiceData[r].invAmount == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else if (
            this.ffTallyInvoiceData[r].currency == "" ||
            this.ffTallyInvoiceData[r].currency == undefined
          ) {
            this.alert.content =
              "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
            this.$refs["addPop"].open();
            return false;
            break;
          } else {
            console.log("All fields are Entered");
          }
        }
      } else {
        this.alert.content = "Please Add minimum 1 Chagers to Tally";
        this.$refs["addPop"].open();
        return false;
        return false;
      }

      if (this.ffInvoiceModal.clientName == "") {
        this.alert.content = "Please Enter Client Name";
        this.$refs["addPop"].open();
        return false;
      }
      this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;

      this.ffInvoiceModal["TPTGRNDATA"] = this.TPTGRNDATA;

      if (
        this.newJobType.indexOf("CC") >= 0 &&
        this.ffInvoiceModal.containerDetailsCC.length > 0
      ) {
        this.ffInvoiceModal.containerDetails = this.ffInvoiceModal.containerDetailsCC;
      }

      this.ffInvoiceModal["buttonId"] = id;
      let total = 0;

      this.ffTallyInvoiceData.map((x) => {
        if (x.ffType == "TRANSPORT CHARGES") {
          this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
        }
        if (x.ffType == "TOLL CHARGES") {
          this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
        }
        let dummy = parseFloat(x.invAmount) + total;
        total = dummy;
      });

      this.ffInvoiceModal.totalAmount = total;
      //console.log(this.ffInvoiceModal);

      if (this.validateInvoice != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/addBillingTally_NewV3.php`,
          data: JSON.stringify(this.ffInvoiceModal),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              this.getData(id);

              // this.showMoreNewItem = false;
              //   location.reload();
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
 SelectedAll() {
   for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
if(this.slectedAllStatus=='1'){  
this.ffTallyInvoiceData[r].slectedStatus="1"
}else{
this.ffTallyInvoiceData[r].slectedStatus="0"

}
   }
console.log(this.ffTallyInvoiceData)
// if(this.ffTallyInvoiceData[index].slectedStatus && this.ffTallyInvoiceData[index].slectedStatus=='1'){
// console.log("activate")
// this.ffTallyInvoiceData[index].slectedStatus=1;
// }else{
// console.log("dactivate",this.ffTallyInvoiceData[index].slectedStatus)
//  this.ffTallyInvoiceData[index].slectedStatus=0;
// }
    
    },



    removeGRN(index, item) {
      let i = 0;
      while (i < this.ffTallyInvoiceData.length) {
        let x = item.invoiceId;
        if (this.ffTallyInvoiceData[i].mainffId == x) {
          this.ffTallyInvoiceData.splice(i, 1);
        } else {
          ++i;
        }
      }

      this.TPTGRNDATA.splice(index, 1);
console.log(this.TPTGRNDATA)
    },

    removeFFContainer(index, itemAll) {
      // console.log(itemAll);
      let p = 0;
      while (p < this.ffTallyInvoiceData.length) {
        let y = itemAll.FFInvIdId;
        if (this.ffTallyInvoiceData[p].mainffId == y) {
          this.ffTallyInvoiceData.splice(p, 1);
        } else {
          ++p;
        }
      }
      this.ffInvoiceModal.containerDetails.splice(index, 1);
    },

    addQuotationFields() {
      let tableFields = {
slectedStatus:"1",
        ffType: "",
        containerType: "",
        quantity: "",
        ffSellingRate: "",
        exchRate: "1",
        sellingRateFinal: "",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: "",
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    getData(id) {
      this.ffTallyInvoiceData = [];
      this.isLoading = true;
      let type_Size = {
        itemCode: "itemCode",
        allModuleId: this.$route.params.billingId,
        //allModuleId: this.$sessionsStorage.get("editSalesExId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getDataTallyBilling_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            //  console.log(data);
            if (data.billingLocationData.length > 0) {
              this.billingLocationData = data.billingLocationData;
            } else {
              this.billingLocationData = [];
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }

 if (data.allClients.length > 0) {
              this.clientData = data.allClients;
            } else {
              this.clientData = [];
            }

            if (data.containerMasterData.length > 0) {
              this.containerMasterData = data.containerMasterData;
            } else {
              this.containerMasterData = [];
            }

            if (data.mainExecutionDetails.length > 0) {
              this.mainExecutionDetails = data.mainExecutionDetails;
              this.shipmentType = data.mainExecutionDetails[0].shipmentType;
              this.ffInvoiceModal.jobNo =
                data.mainExecutionDetails[0].mainSalesSeries;
              this.ffInvoiceModal.sentForRevisedApproval =
                data.mainExecutionDetails[0].sentForRevisedApproval;
              this.ffInvoiceModal.revisedActionTakenFromMail =
                data.mainExecutionDetails[0].revisedActionTakenFromMail;

              if (this.mainExecutionDetails[0].clientType != "3") {

                this.ffInvoiceModal.clientName =
                  data.mainExecutionDetails[0].clientName;
 this.ffInvoiceModal.clientId =
                  data.mainExecutionDetails[0].clientId;

                this.ffInvoiceModal.acutalclientForOverSea =
                  data.mainExecutionDetails[0].exporter;
                this.ffInvoiceModal.stateName =
                  data.mainExecutionDetails[0].stateName;
                this.ffInvoiceModal.clientgst =
                  data.mainExecutionDetails[0].gstCode +
                  data.mainExecutionDetails[0].GSTN;
                this.ffInvoiceModal.contact =
                  data.mainExecutionDetails[0].kycContact;
                this.ffInvoiceModal.adress =
                  data.mainExecutionDetails[0].corporateAddress;
              }

              this.ffInvoiceModal.allModuleId =
                data.mainExecutionDetails[0].allModuleId;
              this.ffInvoiceModal.ccTypeExImp =
                data.mainExecutionDetails[0].transportType;
              this.ffInvoiceModal.shippingLine =
                data.mainExecutionDetails[0].shippingLine;
              this.getServicesData();
            }
            if (data.billingTableData.length > 0) {
              this.billingTableData = data.billingTableData;

              //    console.log(this.billingTableData);

              // this.billingTableData.map((x, index) => {
              //   if (
              //     x.BillingSeries.slice(-1) == "F" &&
              //     x.CREATED != "" &&
              //     x.CREATED != "0"
              //   ) {
              //     let defaultNo = 0;
              //     if (x.BillingSeries.slice(-1) == "F") {
              //       this.ffInvoiceModal.secondFF = 1;
              //     } else {
              //       let numberDummy1 = x.BillingSeries.slice(-1);

              //       this.ffInvoiceModal.secondFF =
              //         parseInt(numberDummy1) + parseInt(defaultNo);
              //     }

              //     // console.log(this.ffInvoiceModal.secondFF);
              //   }
              //   if (x.CREATED != "" && x.CREATED != "0") {
              //     let defaultNo = 1;

              //     if (x.BillingSeries.substr(x.BillingSeries - 1) == "T") {
              //       this.ffInvoiceModal.multiTPT = 1;
              //     } else {
              //       let numberDummy = x.BillingSeries.slice(-1);
              //       this.ffInvoiceModal.multiTPT =
              //         parseInt(numberDummy) + parseInt(defaultNo);
              //     }
              //   }
              // });

              this.disableJobType = data.billingTableData[0].jobType;
            } else {
              this.billingTableData = [];
            }
            if (id == "1") {
              this.showMoreItem();
              Object.keys(this.ffInvoiceModal).map((x) => {
                this.ffInvoiceModal[x] = "";
              });
            }
            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }

            if (data.mainExecutionDetails.length > 0) {

 let arryNewBillBranch = this.billingLocationData.filter((x) => {
if(x.branchLocation){
 return x.branchLocation.split(',').includes(data.mainExecutionDetails[0].addedBy_user_baseLocation);
}
       // return x.branchLocation == data.mainExecutionDetails[0].billingLocationId;
      });


      if (arryNewBillBranch.length > 0) {
 this.ffInvoiceModal.billingLocationId =
          arryNewBillBranch[0].billingLocationId;
        this.ffInvoiceModal.billingLocationName =
          arryNewBillBranch[0].billingLocation;


      }

            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/paymentDetail"
      // });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// TallyBillingMerge.vue?90f3c0a2